import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-login-template',
  templateUrl: './login-template.component.html',
  styleUrls: ['./login-template.component.scss']
})
export class LoginTemplateComponent implements OnInit {

  @Input() img;

  constructor() { }

  ngOnInit(): void {
  }

}
